import { render, staticRenderFns } from "./CheckActividad.vue?vue&type=template&id=5887d1d2&"
import script from "./CheckActividad.vue?vue&type=script&lang=ts&"
export * from "./CheckActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5887d1d2', component.options)
    } else {
      api.reload('5887d1d2', component.options)
    }
    module.hot.accept("./CheckActividad.vue?vue&type=template&id=5887d1d2&", function () {
      api.rerender('5887d1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/InformeActividad/CheckActividad.vue"
export default component.exports